import React from "react";

import Blocks from "components/form/Blocks";

import useProductApi from "hooks/api/private/useProductApi";

function ProductBlocksForm({ productId }: { productId: string }) {
    const { getOneProduct } = useProductApi();

    const [blockGroupId, setBlockGroupId] = React.useState<string | null>(null);

    React.useEffect(() => {
        const [apiCall, abortController] = getOneProduct({ id: productId });

        apiCall.then((product) => setBlockGroupId(product.block_group_id));

        return () => abortController.abort();
    }, [getOneProduct, productId]);

    return <>{blockGroupId && <Blocks blockGroupId={blockGroupId} />}</>;
}

export default ProductBlocksForm;
